<template>
  <ul class="btn-wrapper">
    <li v-if="isusecompletion === 'Y'" @click="clickCompletion">
      <p>수료 기준</p>
      <img src="@/assets/imgs/common/more.png" alt="더보기" />
    </li>
    <li v-if="isuseroadmap" @click="clickRoadMap">
      <p>레벨별 과정로드맵 보기</p>
      <img src="@/assets/imgs/common/more.png" alt="더보기" />
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    /**
     * 수료기준 사용여부
     */
    isusecompletion: {
      type: String,
      required: false,
      default: "",
    },
    /**
     * 과정로드맵 사용여부
     */
    isuseroadmap: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["roadMapEmit", "completionEmit"],
  setup(_, { emit }) {
    const clickRoadMap = () => {
      emit("roadMapEmit");
    };

    const clickCompletion = () => {
      emit("completionEmit");
    };

    return {
      clickRoadMap,
      clickCompletion,
    };
  },
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  min-width: 1200px;
  max-width: 1200px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -30px;
  display: flex;
  justify-content: flex-end;
  gap: 0 12px;

  li {
    width: 244px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: $medium;
    color: $white;
    padding: 18px 22px;
    border-bottom-left-radius: 14px;
    cursor: pointer;

    &:first-child {
      background-color: $blue;
    }

    &:last-child {
      background-color: $black;
    }
  }
}
</style>
